export default {
    onChangePermissionItem: 'userPermission.onChangePermissionItem',
};
